// extracted by mini-css-extract-plugin
export default {"buttonSubmit":"styles_buttonSubmit__y5ibu"};